const getParentPath = path => {
  const index = path.lastIndexOf('.')
  return index === -1 ? null : path.substring(0, index)
}

export default getParentPath
